import { baseUniDriverFactory } from '../test-utils/utils/unidriver';

export const boxDriverFactory = base => {
  return {
    ...baseUniDriverFactory(base),
  };
};
